import { Box, Stack, Tabs, Typography, styled as muiStyled, styled } from '@mui/material';
import { abyssColors } from '@/theme/colors';

export const containerStyles = {
  width: 1,
  position: 'relative',
  mt: '64px',
  pt: '16px',
  pb: 0,
  overflow: 'auto',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
};

export const ReportTabs = muiStyled(Tabs)(() => ({
  width: '100%',
  '& .MuiTabs-flexContainer': {
    gap: '16px',
  },
  '& .MuiTab-root': {
    padding: '12px 15px',
    fontSize: '1.6rem',
    fontStyle: 'normal',
    letterSpacing: '0',
    fontWeight: 500,
    minWidth: 'fit-content',
    minHeight: 'fit-content',
  },
  '& .Mui-selected': {
    color: `${abyssColors.primary[700]} !important`,
    fontWeight: 700,
  },
  '& .MuiTab-textColorPrimary': {
    color: abyssColors.primary[400],
  },
  '& .MuiTabs-indicator': {
    backgroundColor: abyssColors.primary[700],
    height: '4px',
    borderRadius: '4px',
  },
}));

export const ReportsMainStyles = {
  width: '100%',
  maxWidth: { xl: '1424px', md: '1100px' },
  marginX: 4,
  marginBottom: 8,
  height: 'fit-content',
};

export const Card = muiStyled(Box)(() => ({
  borderRadius: '12px',
  backgroundColor: abyssColors.primary[50],
  border: `1px solid ${abyssColors.primary[100]}`,
  padding: '16px 16px 24px 16px',
  cursor: 'pointer',
}));

export const ReportName = muiStyled(Typography)(() => ({
  fontSize: '1.6rem',
  fontWeight: 700,
  color: abyssColors.primary[700],
  lineHeight: '24px',
  paddingRight: '5px',
  maxWidth: '60%',
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
}));

export const ReportDetail = muiStyled(Stack)(() => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '8px',
}));

export const MainLabel = muiStyled(Typography)(() => ({
  fontSize: '1.2rem',
  fontWeight: 400,
  color: abyssColors.primary[500],
  lineHeight: 'normal',
  textAlign: 'right',
}));

export const DetailLabel = muiStyled(Typography)(() => ({
  fontSize: '1.2rem',
  fontWeight: 400,
  color: abyssColors.primary[400],
  lineHeight: 'normal',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
}));

export const DetailValue = muiStyled(Typography)(() => ({
  fontSize: '1.2rem',
  fontWeight: 400,
  color: abyssColors.primary[500],
  lineHeight: 'normal',
  width: 'fit-content',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

export const Panel = muiStyled(Box)(() => ({
  paddingTop: '32px',
  paddingBottom: '16px',
}));

export const FloatingLine = muiStyled(Box)(() => ({
  borderTop: '1px solid #D9D9D9',
  width: '100%',
  position: 'relative',
  bottom: '2px',
  zIndex: '-1',
}));

const Chip = muiStyled(Box)(() => ({
  display: 'inline-flex',
  padding: '0px 4px',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  borderRadius: '8px',
  backgroundColor: abyssColors.primary[100],
  height: 'fit-content',
}));

export const ChipLabel = muiStyled(Typography)(() => ({
  fontSize: '1.2rem',
  fontWeight: 500,
  color: abyssColors.primary[500],
  lineHeight: 'normal',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
}));

export const StatusChip = styled(Chip)(() => ({
  padding: '2px 6px',
}));

export const AssigneeContainer = styled(Box)(() => ({
  width: '26px',
  height: '26px',
  borderRadius: '50%',
  backgroundColor: abyssColors.tertiary[500],
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
